import { SkillType } from '../../../data/types/crew-member/skill';
import { IShip } from '../../../data/types/ship/ship';
import { getSkillBonus } from './skill-bonus';

export const applyPersonalEquipment = (skillType: SkillType) => (
  ship: IShip,
) => (skillLevel: number): number => {
  return skillLevel + getSkillBonus(skillType)(ship);
};
